var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"resource-capacity"},[_c('NcTextField',{attrs:{"label":_vm.placeholder,"type":"number","min":"0","placeholder":_vm.placeholder,"value":_vm.value},on:{"input":_vm.changeValue}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }